import React from 'react';
import { CurrencyInputStyle } from './currencyInput.style';

const CurrencyInput = (props) => {
	const {
		value,
		handleChange,
		decimalSeparator,
		thousandSeparator,
		precision,
		name,
	} = props;

	return (
		<CurrencyInputStyle
			name={name}
			className='form-control'
			value={value}
			onChangeEvent={handleChange}
			decimalSeparator={decimalSeparator || ','}
			thousandSeparator={thousandSeparator || '.'}
			precision={precision || '1'}
		/>
	);
};

export default CurrencyInput;
